import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import {JsonService} from "../../../services/core/json.service";
import {ProductApiResources} from "./product.constants";

@Injectable({
  providedIn: 'root'
})
export class ProductDataService {
  private baseURL;

  constructor(
    private http: HttpClient,
    private jsonService: JsonService,
  ) {
    this.baseURL = ProductApiResources;
  }

  list(model: any = null): Observable<any> {
    const endPoint = `${this.baseURL.list}`;
    return this.http.post<any>(endPoint, model)
                    .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  search(model: any = null): Observable<any> {
    const endPoint = `${this.baseURL.search}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  create(model: any): Observable<any> {
    const endPoint = `${this.baseURL.create}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  
  detail(id: any, params?: any): Observable<any> {
    const endPoint = `${this.baseURL.detail}/${id}`;
    return this.http.get<any>(endPoint, { params }) 
      .pipe(
        tap(data => this.jsonService.doStringify(data)), 
        catchError(this.errorHandlerMessage)
      );
  }

  update(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.update}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  delete(id:any): Observable<any> {
    const endPoint = `${this.baseURL.delete}/${id}`;
    return this.http.delete<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Bulk delete: DELETE products/delete/multiple with { product_ids: [...] }
  deleteMultiple(productIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteMultiple}`;
    return this.http.request<any>('delete', endPoint, { body: { product_ids: productIds } })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Pre-check which of the selected products can be deleted (and why not, for the rest)
  deleteAvailability(productIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteAvailability}`;
    return this.http.post<any>(endPoint, { product_ids: productIds })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  discontinue(id:any): Observable<any> {
    const endPoint = `${this.baseURL.discontinue}/${id}`;
    return this.http.post<any>(endPoint, [])
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getTypes(): Observable<any> {
    const endPoint = `${this.baseURL.types}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  createManufacturer(model: any): Observable<any> {
    const endPoint = `${this.baseURL.AddManufacturer}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  getManufacturers(): Observable<any> {
    const endPoint = `${this.baseURL.manufacturers}`;
    return this.http.post<any>(endPoint,[])
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  changeAttribute(model: any): Observable<any> {
    const endPoint = `${this.baseURL.changeAttribute}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  onChangeStatus(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.changeStatus}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  updatePrice(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.updatePrice}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  addVendor(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.addVendor}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  setDefaultVendor(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.setDefaultVendor}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  getStatus(): Observable<any> {
    const endPoint = `${this.baseURL.statusList}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  // setVendorAsDefault(model: any): Observable<any> {
  //   const endPoint = `${this.baseURL.setVendorAsDefault}`;
  //   return this.http.post<any>(endPoint, model)
  //     .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  // }

  deleteProductVendor(model: any): Observable<any> {
    const endPoint = `${this.baseURL.productVendorAsDelete}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  removeProductVendor(id: any , model: any): Observable<any> {
    const endPoint = `${this.baseURL.removeProductVendor}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getSpecificationFiles(model: any): Observable<any> {
    const endPoint = `${this.baseURL.getSpecificationFiles}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  createSpecificationFiles( model: any): Observable<any> {
    const endPoint = `${this.baseURL.createSpecificationFiles}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  sortProductCategoryItems(model: any): Observable<any> {
    const endPoint = `${this.baseURL.sortProductCategoryItems}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  saveCategorySelectedVendor(model: any): Observable<any> {
    const endPoint = `${this.baseURL.saveCategorySelectedVendor}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))), catchError(this.errorHandlerMessage));
  }

  saveCategorySelectedSubcontractor(model: any): Observable<any> {
    const endPoint = `${this.baseURL.saveCategorySelectedSubcontractor}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))), catchError(this.errorHandlerMessage));
  }

  copyProduct(id: any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.copy}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Import Methods
  downloadSampleFile(): Observable<any> {
    const endPoint = `${this.baseURL.downloadSample}`;
    return this.http.get(endPoint, { responseType: 'blob' })
      .pipe(catchError(this.errorHandlerMessage));
  }

  uploadImportFile(file: File): Observable<any> {
    const endPoint = `${this.baseURL.uploadImport}`;
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(endPoint, formData)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  validateImportData(data: any): Observable<any> {
    const endPoint = `${this.baseURL.validateImport}`;
    return this.http.post<any>(endPoint, data)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  executeImport(data: any): Observable<any> {
    const endPoint = `${this.baseURL.executeImport}`;
    return this.http.post<any>(endPoint, data)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  getImportJobStatus(jobId: string): Observable<any> {
    const endPoint = `${this.baseURL.importStatus}/${jobId}`;
    return this.http.get<any>(endPoint)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  // Import History Methods (reuse existing with module_id=10)
  getImportHistory(params: any = {}): Observable<any> {
    const endPoint = `${this.baseURL.importHistory}`;
    let httpParams = new HttpParams();
    
    // Always add product module_id
    httpParams = httpParams.set('module_id', '10');
    
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        httpParams = httpParams.set(key, params[key]);
      }
    });
    
    return this.http.get<any>(endPoint, { params: httpParams })
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  getImportHistoryDetails(id: number): Observable<any> {
    const endPoint = `${this.baseURL.importHistory}/${id}`;
    return this.http.get<any>(endPoint)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  deleteImportHistory(id: number): Observable<any> {
    const endPoint = `${this.baseURL.importHistory}/${id}`;
    return this.http.delete<any>(endPoint)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  getImportStats(params: any = {}): Observable<any> {
    const endPoint = `${this.baseURL.importHistory}/stats`;
    let httpParams = new HttpParams();
    
    // Always add product module_id
    httpParams = httpParams.set('module_id', '10');
    
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        httpParams = httpParams.set(key, params[key]);
      }
    });
    
    return this.http.get<any>(endPoint, { params: httpParams })
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
